<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <div class="md-layout">
          <div class="md-layout-item md-size-100 terms">
            <tnc></tnc>
          </div>
          <div class="md-layout-item md-size-100">
            <md-checkbox v-model="tnc_aim" @change="changeState">{{
              $t("I agree to AIM Robotics's TERMS & CONDITIONS")
            }}</md-checkbox>
          </div>
          <div class="md-layout-item md-size-100">
            <md-checkbox v-model="hasCertification" @change="changeState"
              >{{ $t("I have passed the") }} </md-checkbox
            ><a
              class="small-exam"
              target="_blank"
              href="https://tc.canada.ca/en/aviation/drone-safety/drone-pilot-licensing/take-drone-pilot-online-exam-small-advanced-exam"
              >{{ $t("Small Advanced Exam") }}</a
            >
          </div>
          <div
            v-if="booking.clubId && !isMAACMember"
            class="md-layout-item md-size-100"
          >
            <md-checkbox v-model="hasMaacApproved" @change="changeState">{{
              $t(
                "I confirm that I must register for MAAC membership before undergoing the flight review."
              )
            }}</md-checkbox>
          </div>
          <div
            v-if="showTermsError"
            class="md-layout-item md-size-100 text-danger"
          >
            {{ $t("You need to accept Terms & Conditions to continue.") }}
          </div>
          <div
            v-if="showExamError"
            class="md-layout-item md-size-100 text-danger"
          >
            {{
              $t(
                "You need to confirm you have passed the Small Advanced Exam to continue."
              )
            }}
          </div>
          <div
            v-if="booking.clubId && !isMAACMember && showHasMaacApprovedError"
            class="md-layout-item md-size-100 text-danger"
          >
            {{
              $t("You need to confirm you will register for MAAC membership.")
            }}
          </div>
        </div>
      </div>
    </div>
    <md-progress-spinner
      md-mode="indeterminate"
      class="custom-page-spinner"
      v-if="loading"
    ></md-progress-spinner>
  </div>
</template>
<script>
import Tnc from "../PilotTnc.vue";
import { mapFields } from "vuex-map-fields";
import { booking, checkUserRoles } from "@/services/flightReview.service.js";
import swal from "sweetalert2";

export default {
  components: { Tnc },
  data() {
    return {
      tnc_aim: false,
      showExamError: false,
      hasCertification: false,
      showTermsError: false,
      hasMaacApproved: false,
      showHasMaacApprovedError: false,
      loading: false,
      isMAACMember: false,
      isPublicService: false
    };
  },
  computed: {
    ...mapFields("flightReview", ["booking"]),
  },
  async mounted() {
    const { member_flag, public: public_service  } = await checkUserRoles();
    this.isMAACMember = member_flag
    this.isPublicService = public_service
  },
  methods: {
    changeState() {
      if (this.tnc_aim) {
        this.showTermsError = false;
      }
      if (this.hasCertification) {
        this.showExamError = false;
      }
      if (this.hasMaacApproved) {
        this.showHasMaacApprovedError = false;
      }
    },
    validate() {
      if (!this.tnc_aim) {
        this.showTermsError = true;
        return;
      }

      if (!this.hasCertification) {
        this.showExamError = true;
        return;
      }

      if (this.booking.clubId && !this.isMAACMember && !this.hasMaacApproved) {
        this.showHasMaacApprovedError = true;
        return;
      }

      if (this.loading) {
        return;
      }
      const _self = this;
      swal
        .fire({
          text: this.$t("Do you want to submit the order now?"),
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          confirmButtonText: this.$t("Yes"),
          cancelButtonText: this.$t("Cancel"),
          buttonsStyling: false
        })
        .then(async function({ value }) {
          if (!value) return;
          let {
            addressId,
            reviewerId,
            packageId,
            reviewStartDate,
            reviewEndDate,
            selectedPackageKeys
          } = _self.booking;
          _self.loading = true;
          try {
            await booking({
              address_id: addressId,
              start_date: reviewStartDate,
              end_date: reviewEndDate,
              package_ids: selectedPackageKeys,
              reviewer_id: reviewerId,
              public_service: _self.isPublicService
            });
            _self.loading = false;
            _self.$store.commit("flightReview/updateBooking", {
              addressId: "",
              reviewerId: "",
              packageId: "",
              reviewStartDate: "",
              reviewEndDate: "",
              clubId: "",
              alwaysAvailable: false,
              selectedPackageKeys: [],
              packageList: []
            });
            _self.$router.replace("/flight-review/bookingList");
          } catch {
            _self.loading = false;
          }
        });
    }
  }
};
</script>
<style>
.terms {
  background-color: #e6e6e6;
  overflow: auto;
  height: 400px;
  width: 100%;
}
.small-exam {
  position: relative;
  left: -20px;
  top: -6px;
}
</style>
